var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:'elfsight-app-' + _vm.elfsightKey},[_c('div',{staticClass:"d-flex justify-center py-10"},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }